import { render, staticRenderFns } from "./cartsTab.vue?vue&type=template&id=6ca34644&"
import script from "./cartsTab.vue?vue&type=script&lang=js&"
export * from "./cartsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports